import { findTypeByNumber } from './cardType';

export const makeCreditCardApiPayload = (payload, userData) => {
  const {
    cardNumber,
    securityCode,
    savedCard,
    expirationDate: rawExpirationDate,
    cardType,
    customerName,
    token,
    eci,
    language,
    ...rest
  } = payload;

  const paymentOption = cardType || findTypeByNumber(cardNumber).type.toUpperCase();

  const [month, year] = rawExpirationDate.split('/');
  const expirationDate = month && year ? `${year}${month}` : rawExpirationDate;

  return {
    ...rest,
    token,
    paymentOption,
    maskedCardNumber: cardNumber.replace(new RegExp(' ', 'g'), ''),
    expirationDate,
    cardSecurityCode: securityCode,
    savedCard: Boolean(savedCard),
    customerEmail: userData.email,
    customerName: customerName || userData.name,
    eci: eci || 'ECOMMERCE',
    language: language || 'en',
    phoneNumber: userData.phone_number,
    settlementReference: null,
  };
};

export const getRemainingCreditTerms = (usage, creditLimit) => (1 - usage) * creditLimit;
